module.exports = __webpack_public_path__ + "static/media/90.61a89eb0.jpg";